import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';
import { createModuleStreamFetcher } from './createModuleStreamFetcher';

export default createModuleStreamFetcher({
  url: '/module/watching',
  schema: userSchema,
});
